<ng-container *ngIf="!isProd">
  <brightside-web-dev-menu></brightside-web-dev-menu>
</ng-container>
<bw-theme-legacy *ngIf="mobileLayoutType !== LayoutStyle.HIDE_EVERYTHING;else spinner">
  <ng-container *ngIf="isMobileDevice && mobileLayoutType !== LayoutStyle.PUBLIC_ACCESS; else desktopContent">
    <bw-toast-legacy (emit)="toastClicked($event)" [toastObs]="toastService.onShowToast()"></bw-toast-legacy>
    <div *ngIf="mobileViewEvent" [brightsideWebFb]="{ event_name: mobileViewEvent, custom: { company: customerName } }"></div>
    <div class="mobile-layout flex-column center">
      <div class="mobile-layout-logo hidden-print mb-md">
        <img src="../assets/brightsideLockup.svg" alt="Brightside logo" width="124" class="mb-xs" />
        <div class="customer-logo" *ngIf="customerLanding">
          <typography-legacy text-small-regular class="secondary-text mr-xxs no-wrap"
            ><span [innerHTML]="'BROUGHT_BY' | translate"></span
          ></typography-legacy>
          <img src="/cdn.gobrightside.com/resources/assets/{{ customerName }}-logo.png" alt="" height="16" />
        </div>
      </div>
      <div class="mobile-layout-graphic mb-smd flex-item-rigid">
        <img [src]="mobileGraphic" alt="brightside welcome graphic, a guy with a key" style="max-width: fit-content" />
      </div>
      <div class="mobile-layout-content flex-item-flexible mb-smd" style="width: 260px; margin: auto">
        <typography-legacy headline-semibold>{{ mobileHeadline | translate }}</typography-legacy>
        <bw-paragraph-legacy textStyle="Body2">{{ mobileParagraph | translate }}</bw-paragraph-legacy>
        <!-- Must be hidden, but required for email verification -->
        <div class="hidden-router" *ngIf="isVerify">
          <router-outlet></router-outlet>
        </div>
      </div>
      <div class="mobile-layout-footer flex-item-rigid" *ngIf="!isVerifyV3">
        <button bw-button-legacy fluidWidth (click)="downloadApp()">{{ mobileCta | translate }}</button>
      </div>
    </div>
  </ng-container>
</bw-theme-legacy>

<ng-template #desktopContent>
  <ng-container *ngIf="isLandingLayout || !isLoggedIn; else loggedInTemplate">
    <bw-toast-legacy (emit)="toastClicked($event)" [toastObs]="toastService.onShowToast()"></bw-toast-legacy>
    <bw-page-legacy class="pt-lg">
      <bw-topbar-legacy page-header class="hidden-print" (logo)="logoClick()">
        <div class="customer-logo flex-row" *ngIf="customerLanding">
          <typography-legacy text-small-regular class="secondary-text bs-mid-gray no-wrap mr-xs"
            ><span [innerHTML]="'BROUGHT_BY' | translate"></span
          ></typography-legacy>
          <img src="{{ env.cdnUrl }}resources/assets/{{ customerName }}-logo.png" alt="" />
        </div>
        <div class="action">
          <div class="flex-row">
            <div class="flex-item" *ngIf="displayLangSelector">
              <brightside-web-language-selector [bypassPut]="true"></brightside-web-language-selector>
            </div>
            <ng-container *ngIf="!isLoggedIn && showAppLink">
              <ng-template #appLinkNotSent>
                <div class="flex-item">
                  <button bw-outlined-button-legacy (click)="getTheApp()">{{ 'DOWNLOAD_MOBILE_APP' | translate }}</button>
                </div>
              </ng-template>
              <div class="flex-row" *ngIf="appLinkSent; else appLinkNotSent">
                <span class="body mr-sm bs-mid-gray">{{ 'APP_LINK_SENT' | translate }}</span>
                <a bw-anchor-legacy class="bs-blue" (click)="getTheApp()">{{ 'RETRY' | translate }}</a>
              </div>
            </ng-container>
          </div>
        </div>
      </bw-topbar-legacy>
      <div page-primary-section *ngIf="isLandingLayout && showCopy" [ngClass]="{ 'mr-md': !isMobileWidth }">
        <brightside-web-how-we-help
          [heading]="landingHeading"
          [bodyCopy]="landingBodyCopy"
          [iconGroupTitle]="landingIconGroupTitle"
          (introVideoClicked)="showIntroVideo = true"
        ></brightside-web-how-we-help>
        <ng-container *ngIf="!isMobileWidth">
          <ng-container *ngTemplateOutlet="FAContact"></ng-container>
        </ng-container>

        <div class="media-small-center" [ngClass]="{ 'mr-lg': !isMobileWidth }">
          <bw-paragraph-legacy color="var(--gray-50)">
            <span [innerHTML]="'BS_CUSTOMER_MSG' | translate"></span>
          </bw-paragraph-legacy>
        </div>
      </div>
      <div page-secondary-section>
        <router-outlet></router-outlet>
      </div>
      <div page-footer *ngIf="isLandingLayout">
        <ng-container *ngIf="isMobileWidth && customerLanding">
          <ng-container *ngTemplateOutlet="FAContact"></ng-container>
        </ng-container>
        <div class="media-small-center">
          <bw-caption-legacy
            >© {{ currentYear }} Brightside |
            <a
              bw-anchor-legacy
              anchorStyle="text-small-regular"
              target="_blank"
              (click)="(true)"
              [href]="'//www.gobrightside.com/terms-of-service' | safe"
            >
              Terms
            </a>
            |
            <a
              bw-anchor-legacy
              anchorStyle="text-small-regular"
              target="_blank"
              (click)="(true)"
              [href]="'//www.gobrightside.com/privacy-policy' | safe"
            >
              Privacy
            </a>
            <span style="color: white">
              {{ buildVersion }}
            </span>
          </bw-caption-legacy>
        </div>
      </div>
    </bw-page-legacy>
  </ng-container>

  <router-outlet name="modal"></router-outlet>

  <bw-modal-legacy *ngIf="showLogoutWarningModal" modalWidth="medium">
    <typography-legacy title-medium>{{ 'SESSION_EXP_TITLE' | translate }}</typography-legacy>
    <div class="body">
      <bw-paragraph-legacy>{{ 'SESSION_EXP_DESC' | translate : { timeout: timeToLogout } }}</bw-paragraph-legacy>
    </div>
    <div class="footer">
      <div class="flex-row row-reverse">
        <button bw-button-legacy (click)="dismissAutoLogout()">{{ 'SESSION_EXP_CONT_CTA' | translate }}</button>
        <a bw-anchor-legacy (click)="logout()" style="margin: 0 16px">{{ 'SIGN_OUT' | translate }}</a>
      </div>
    </div>
  </bw-modal-legacy>

  <ng-template #loggedInTemplate>
    <div *ngIf="!isFullScreenLayout; else loggedInTemplateFullScreen" class="left-nav-wrapper">
      <bw-topbar-legacy page-header (logo)="logoClick()" *ngIf="!isOnboardingComplete">
        <div class="customer-logo flex-row" *ngIf="customerLanding">
          <typography-legacy text-small-regular class="secondary-text bs-mid-gray no-wrap mr-xs">{{
            'BROUGHT_BY' | translate
          }}</typography-legacy
          ><img src="//cdn.gobrightside.com/resources/assets/{{ customerName }}-logo.png" alt="" />
        </div>
      </bw-topbar-legacy>
      <div class="left-nav hidden-print" *ngIf="isOnboardingComplete">
        <div class="brightside-logo pointer hidden-print" (click)="logoClick()">
          <img src="../assets/brightsideLockup.svg" alt="" />
        </div>
        <nav class="app-menu">
          <ul>
            <li routerLinkActive="active">
              <a [routerLink]="['home']"
                ><bw-icon-legacy [iconName]="'home'" horizontalSpace="mr-xs"></bw-icon-legacy>
                <span class="link-text">{{ 'HOME' | translate }}</span>
              </a>
            </li>
            <li routerLinkActive="active">
              <a [routerLink]="['ways-we-can-help']"
                ><bw-icon-legacy [iconName]="'search'" horizontalSpace="mr-xs"></bw-icon-legacy>
                <span class="link-text">{{ 'WAYS_WE_CAN_HELP' | translate }}</span></a
              >
            </li>
            <li>
              <a (click)="openChat()"
                ><bw-icon-legacy [iconName]="'chat'" horizontalSpace="mr-xs"></bw-icon-legacy>
                <span class="link-text">{{ 'MESSAGE_FA' | translate }}</span>
              </a>
            </li>

              <brightside-web-service-notifications-menu></brightside-web-service-notifications-menu>

            <li>
              <a [routerLink]="[{ outlets: { modal: ['settings', 'profile'] } }]" [relativeTo]="null"
                ><bw-icon-legacy [iconName]="'user'" horizontalSpace="mr-xs"></bw-icon-legacy>
                <span class="link-text">{{ 'PROFILE' | translate }}</span></a
              >
            </li>
            <li>
              <a [routerLink]="[{ outlets: { modal: ['settings', 'settings'] } }]" [relativeTo]="null"
                ><bw-icon-legacy [iconName]="'cog'" horizontalSpace="mr-xs"></bw-icon-legacy>
                <span class="link-text">{{ 'SETTINGS' | translate }}</span></a
              >
            </li>
            <li routerLinkActive="active">
              <a [routerLink]="['invite']"
                ><bw-icon-legacy [iconName]="'invite'" horizontalSpace="mr-xs"></bw-icon-legacy>
                <span class="link-text">{{ 'INVITE' | translate }}</span></a
              >
            </li>
            <li>
              <a (click)="logout()"
                ><bw-icon-legacy [iconName]="'sign_out'" horizontalSpace="mr-xs"></bw-icon-legacy>
                <span class="link-text">{{ 'SIGN_OUT' | translate }}</span>
              </a>
            </li>
          </ul>
        </nav>
        <div class="versionStamp">{{ buildVersion }}</div>
      </div>
      <div class="content-wrapper">
        <bw-toast-legacy (emit)="toastClicked($event)" [toastObs]="toastService.onShowToast()"></bw-toast-legacy>
        <div class="content-inner" [ngClass]="{ 'onboarding-complete': isOnboardingComplete }">
          <div class="content-inner-container">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>

    <ng-template #loggedInTemplateFullScreen>
      <div class="left-nav-wrapper full-screen">
        <bw-topbar-legacy page-header (logo)="logoClick()">
          <div class="customer-logo flex-row" *ngIf="customerLanding">
            <typography-legacy text-small-regular class="secondary-text bs-mid-gray no-wrap mr-xs">{{
              'BROUGHT_BY' | translate
            }}</typography-legacy
            ><img src="//cdn.gobrightside.com/resources/assets/{{ customerName }}-logo.png" alt="" />
          </div>
        </bw-topbar-legacy>

        <div class="content-wrapper">
          <bw-toast-legacy (emit)="toastClicked($event)" [toastObs]="toastService.onShowToast()"></bw-toast-legacy>
          <div class="content-inner">
            <div class="content-inner-container">
              <router-outlet></router-outlet>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </ng-template>
</ng-template>

<ng-template #FAContact>
  <div *ngIf="customerNumberLoaded" class="media-small-center mr-md mb-sm" [ngClass]="{ 'mr-md': !isMobileWidth }">
    <bw-paragraph-legacy color="var(--gray-50)" verticalSpace="4">
      <div [innerHTML]="'BRIGHTSIDE_REGISTER_CALL' | translate : { customerNumber: '1' + customerNumber }"></div>
    </bw-paragraph-legacy>
    <bw-caption-legacy>({{ 'BRIGHTSIDE_LANDING_FAHOURS' | translate }})</bw-caption-legacy>
  </div>
</ng-template>

<brightside-web-mobile-app-modal *ngIf="showMobileModal" (ctaClick)="showMobileModal = false"></brightside-web-mobile-app-modal>

<bw-modal-legacy
  *ngIf="showIntroVideo"
  [showCloseButton]="true"
  modalWidth="large"
  (closeModal)="showIntroVideo = false"
>
  <div class="body">
    <bw-video-legacy
      [cdnBase]="env.cdnUrl"
      [isMp4]="true"
      [path]="'videos/explainer/' + languageSelectorService.activeLang + '/explainer.mp4'"
    ></bw-video-legacy>
  </div>
</bw-modal-legacy>

<bw-modal-legacy
  *ngIf="bannerModal.displayMe"
  [showCloseButton]="true"
  (closeModal)="onBannerModalClose(bannerModal.id)"
  modalWidth="medium"
  [brightsideWebFb]="{ event_name: bannerModal.id }"
>
  <typography-legacy title-medium>
    {{ bannerModal.titleKey | translate }}
  </typography-legacy>
  <div class="body">
    <div [innerHTML]="bannerModal.bodyKey | translate"></div>
  </div>
  <div class="footer">
    <div class="flex-row row-reverse">
      <button *ngIf="bannerModal.ctaKey" bw-button-legacy (click)="onBannerModalClose(bannerModal.id)">
        {{ bannerModal.ctaKey | translate }}
      </button>
    </div>
  </div>
</bw-modal-legacy>

<brightside-web-simple-global-modal></brightside-web-simple-global-modal>
<cads-global-modal-host />
<cads-global-toast-host />

<ng-template #spinner><bw-spinner-legacy></bw-spinner-legacy></ng-template>
